import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { MRQDetailsGrid } from "../utils";
import { MCSContext } from "../../MCS.context";
import { useMrqContext } from "../MrqContext";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";

const MrqDetails = () => {
  const { project } = React.useContext(MCSContext);
  const { mrqData } = useMrqContext();

  return (
    <LabelledBox label="MRQ Details">
      <Grid container spacing={2} columns={{ xs: 6.8 }} sx={{ width: "900px" }}>
        {MRQDetailsGrid.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={item.grid}>
              <Typography>{item.label}</Typography>
              {/* <Box sx={{ backgroundColor: "red" }}>{item.label}</Box> */}
            </Grid>
            {/* <Grid item xs={item.label === "From" || item.label === "Title" ? 2.6 : 1} > */}
            <Grid
              item
              xs={["Title", "Document #"].includes(item.label) ? 2.6 : 1}
            >
              {/* <Typography color={"GrayText"}>Values</Typography> */}
              <TextField
                id="outlined-basic"
                variant="outlined"
                hiddenLabel
                size="small"
                disabled
                fullWidth
                value={
                  item.field === "project"
                    ? project.name
                    : item.field === "documentTitle"
                    ? mrqData.document?.title
                    : mrqData?.[item.field]
                }
                inputProps={{ sx: { padding: "2px", pl: "5px" } }}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </LabelledBox>
  );
};

export default MrqDetails;
